import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import LocalizedLink from "./LocalizedLink"
import { useUser } from "../hooks/useUser"
import { CHUNHUIZK_CORPID } from "@/libs/constants"

export default function ProductList({ productEdges, fromView, locale = "zh-CN" }) {
    const { t } = useTranslation()
    const { basicUserInfo } = useUser({ skipLogin: true })
    const [internalViewPermission, setInternalViewPermission] = useState(false)

    const needTranslate = locale.slice(0, 2) !== 'zh'
    const languageCode = locale.split("-")[0]

    const showCategory = fromView !== 'category'

    useEffect(() => {

        const checkLoginStatus = async () => {
            if (basicUserInfo && basicUserInfo.corpid === CHUNHUIZK_CORPID) {
                setInternalViewPermission(true)
            }
        }

        checkLoginStatus()

    }, [basicUserInfo])

    const productsSorted = productEdges.filter(function (p) {
        if (p.node.productStatus === 'internal') {
            return internalViewPermission
        } else {
            return true
        }
    })

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {
                productsSorted
                    .map(function (productNode) {
                        const i18nProduct = productNode.node.i18n.find((p) => p.language === languageCode)
                        const productName = (needTranslate && i18nProduct) ? i18nProduct.name : productNode.node.name
                        const productCategoryName = (needTranslate && i18nProduct) ? i18nProduct.categoryName : productNode.node.categoryName
                        const productStatus = productNode.node.productStatus

                        const imageOriginalUrl = productNode.node.thumbnail ? productNode.node.thumbnail : 'https://via.placeholder.com/150x200.png?text=Image%20Not%20Found'
                        let imageUrl = imageOriginalUrl
                        let domain = (new URL(imageOriginalUrl)).hostname
                        if (domain === "p1.mingdaoyun.cn") {
                            imageUrl = imageOriginalUrl.replace("p1.mingdaoyun.cn", "p1-mingdaoyun.chunhuizk.com")
                        }

                        return (
                            <div className="rounded-md border p-2 flex flex-col justify-between" key={productNode.node.id}>
                                {
                                    productStatus === 'internal' && (
                                        <div className="text-center text-sm mb-2 p-1 bg-orange-700 text-white rounded-sm">
                                            {t(`products.abbr.${productStatus}`)}
                                        </div>
                                    )
                                }
                                <LocalizedLink to={`/products/${productNode.node.id}`}>
                                    <div className="flex">
                                        <div className="flex-none w-20 h-20 mr-4 self-center">
                                            <img
                                                className="rounded-md max-h-28"
                                                src={imageUrl}
                                                alt={productName} />
                                        </div>
                                        <div className="flex-auto">
                                            <span className="text-sm font-bold">{t(productNode.node.departmentPath)}#{productNode.node.id}</span>
                                            <h2>{productName}</h2>
                                            <p className="text-slate-700">{productNode.node.model}</p>
                                        </div>
                                    </div>
                                </LocalizedLink>
                                {showCategory && (
                                    <p className="text-right mt-2">
                                        <LocalizedLink to={`/products/${productNode.node.categoryId}`}>
                                            <span className="py-1 px-2 text-sm rounded-sm text-white bg-gray-700">
                                                {productCategoryName}
                                            </span>
                                        </LocalizedLink>
                                    </p>
                                )}
                            </div>

                        )
                    })
            }
        </div>
    )
}